var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    Add\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,9.25 L10.75,9.25 L10.75,5 L9.25,5 L9.25,9.25 L5,9.25 L5,10.75 L9.25,10.75 L9.25,14.9990234 L10.75,14.9990234 L10.75,10.75 L15,10.75 L15,9.25 Z M10,20 C4.4863281,20 0,15.5136719 0,10 C0,4.4858398 4.4863281,0 10,0 C15.5136719,0 20,4.4858398 20,10 C20,15.5136719 15.5136719,20 10,20 Z M10,1.5 C5.3134766,1.5 1.5,5.3129883 1.5,10 C1.5,14.6865234 5.3134766,18.5 10,18.5 C14.6865234,18.5 18.5,14.6865234 18.5,10 C18.5,5.3129883 14.6865234,1.5 10,1.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.9ec13baa093530fe73d3dd5110ffa4a9.svg";
export { ForwardRef as ReactComponent };